export default __webpack_public_path__ + "static/media/881.241d22dc.png";